module.exports = "/_next/static/images/88da43a6320b83844378c99a0be64994-circles-xs.svg.webp";